import * as zod from "zod";

export enum CreationStatusError {
  TEMPORAL_START_FAILED = "TEMPORAL_START_FAILED",
}

const CreationStatusErrorSchema_ = zod.nativeEnum(CreationStatusError);
export const CreationStatusErrorSchema: zod.ZodType<CreationStatusError> =
  CreationStatusErrorSchema_;

const SubmitDraftReturnResultSchema_ = zod.object({
  returnId: zod.string(),
  creationStatusError: CreationStatusErrorSchema.optional(),
  customerAuthToken: zod.string().optional(),
});
export const SubmitDraftReturnResultSchema: zod.ZodType<SubmitDraftReturnResult> =
  SubmitDraftReturnResultSchema_;
export interface SubmitDraftReturnResult
  extends zod.infer<typeof SubmitDraftReturnResultSchema_> {}
